import useTracker from '@/hooks/useTracker';
import { CLICK_UPLOAD_PAYMENT_PROOF_CONFIRM } from '@services/trackerConst';

const useEventTracker = () => {
  const { trackEvent } = useTracker();

  const eventClickUploadPaymentProofConfirm = () => {
    trackEvent(CLICK_UPLOAD_PAYMENT_PROOF_CONFIRM);
  };

  return {
    eventClickUploadPaymentProofConfirm,
  };
};

export default useEventTracker;
